import { useState, useRef, useEffect } from 'react';
import {
    Autocomplete,
    TextField,
    Paper,
    ListItem,
    Box, Typography
} from '@mui/material';
import debounce from 'lodash/debounce';

const AutocompleteInput = ({ value, onChange, fetchSuggestions, index, label, error, helperText, isEditMode, hasLimit, sx }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    // debounce 付き fetch
    const debouncedFetch = useRef(
        debounce(async (keyword) => {
            if (!keyword) {
                setOptions([]);
                return;
            }

            setLoading(true);
            const res = await fetchSuggestions(keyword);
            setOptions(res || []);
            setLoading(false);
        }, 300)
    ).current;
    useEffect(() => {
        return () => {
            debouncedFetch.cancel();
        };
    }, []);
    return (
        <Autocomplete
            freeSolo
            disabled={!isEditMode}
            options={options}
            loading={loading}
            filterOptions={(x) => x} // MUI のフィルタを無効化（API結果そのまま）
            getOptionLabel={(option) =>
                typeof option === 'string' ? option : option.sku
            }
            inputValue={value}
            sx={sx}
            onInputChange={(_, newValue) => {
                onChange({ target: { name: 'sku', value: newValue } }, index, null);
                debouncedFetch(newValue);
            }}

            onChange={(_, option) => {
                if (!option) return;
                const skuProductName = option?.option_combination && Object.keys(option.option_combination).length > 0
                    ? option.product_name +
                    Object.entries(option.option_combination)
                        .map(([type, value]) => ` / (${type}) ${value}`)
                        .join('')
                    : option.product_name;

                onChange(
                    {
                        target: {
                            name: 'sku',
                            value: option.sku,
                            sku_product_name: skuProductName
                        }
                    },
                    index,
                    option
                );
            }}
            renderInput={(params) => (
                <TextField
                    label={label}
                    {...params}
                    placeholder="品番検索"
                    disabled={!isEditMode}
                    size="small"
                    error={!!error}
                    helperText={helperText}
                    inputProps={{
                        ...params.inputProps,
                        maxLength: 100
                    }}
                />
            )}
            PaperComponent={(props) => (
                <Paper {...props} sx={{ width: 500 }} />
            )}
            renderOption={(props, item) => (
                <ListItem {...props} key={item.sku} sx={{ gap: 1 }}>
                    {hasLimit('ec') &&
                        <img
                            width={40}
                            height={40}
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.image_url}`}
                            alt={item.sku}
                            className="img-cover"
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src =
                                    `${process.env.REACT_APP_IMAGE_BASE_URL}${process.env.REACT_APP_NOIMAGE}`;
                            }}
                        />
                    }
                    <Box>
                        <Typography>{item.sku} - {item.product_name}</Typography>
                        <Typography variant='caption' color='text.secondary'>
                            {item?.option_combination && Object.entries(item.option_combination).map(([type, value]) => (
                                <> {type}: {value}</>
                            ))}</Typography>
                    </Box>
                </ListItem>
            )}
        />
    );
};

export default AutocompleteInput;
